<template>
 <div class="main cf mb60" style="min-height: 582px;padding-top:10px">
	 <div class="VipLeft Boxs">
	 		 
	 		<div class="List" id="leftMenu">
	 <a :class="{cur:tableft == index }"  v-for="(tab, index) in tabs" :key="index" @click="toggleTab(index)" >{{tab.title}}<i></i></a>
	 			 
	 			 	 
	 		</div>
	 	</div>
    
  <Tabhome v-show="tabindex == 0"></Tabhome>   
<Tabkc v-show="tabindex == 1"></Tabkc>  
	<Tabtk v-show="tabindex == 2"></Tabtk> 
	<Tabzl v-show="tabindex == 3"></Tabzl> 
		 <Tabzj v-show="tabindex == 4"></Tabzj> 
  </div>
</template>
<script>
import Tabhome from "./tab/tablist.vue";
import Tabkc from "./tab/tablist1.vue";
import Tabtk from "./tab/tablist2.vue";
import Tabzl from "./tab/tablist3.vue";
import Tabzj from "./tab/tablist4.vue";
export default {
  props: {
    bank: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: () => []
    },
	title:String,
  },
  data() {
    return {
	  list2:"快捷导航",
      liststatus: false,
	  tabs: [
		  {"title":"个人中心","path":"home","show":true},
		  {"title":"我的课程","path":"kc","show":false},
		 
		 
		  ],
	 currentTab: 'home',
		tableft:0,
		tabindex:0,
      studyTab: {},
      studyTabList: [],
      subjectList: [],
	  listall:[
		  "个人中心",
		  "我的课程",
		 
	  ]
    };
  },
  mounted() {
    this.studyTabList = this.list
    // this.initQuestion();
	  this.initTabData()
   
  },
  
     computed: {
		 
       currentTabComponent() {
         return 'tab' + this.currentTab.toLowerCase();
		 
       },
	   list1(){
		   return this.list2;
	   }
     },

  methods: {
		toggleTab(index) {
			 
			this.tableft=index;
			this.tabindex=index;
			 
			 
		  },
		initTabData() {
		 
      if (this.studyTabList.length > 0) {
        this.studyTab = this.studyTabList[0];
		console.log(this.studyTab);
		  this.subjectList = this.studyTabList;
		   console.log(this.subjectList);
		  this.liststatus = true
      }
       
    },
   
  },
  components: {
    Tabhome,
	Tabkc,
	Tabtk,
	Tabzl,
	Tabzj,
  },
};
</script>
<style lang="less" scoped>
// @import "../../../assets/css/var.less";
// @import "../../../assets/css/study.less";

.VipLeft{width: 130px; float: left;background: #fff;padding:15px 0}
.Fixed{position: fixed;top: 0;}
.VipLeft .Head{padding: 7px 0;text-align: center;}
.VipLeft .Head img{width: 56px; height: 56px; border-radius: 50%;margin:0 auto;}
.VipLeft .Head p{height: 30px; line-height: 30px;font-size: 14px; color: #999999;}
.VipLeft .List a{width: 130px;position: relative;  line-height: 40px;display:block;text-align: center; margin-top: 5px;color: #000000;}
.VipLeft .List a i{
	border-color:transparent transparent transparent #f24343; border-style:dashed dashed dashed solid; border-width:9px;position: absolute;
	right: -18px; top: 11px;display: none;}
.VipLeft .List a i,.VipLeft .List a:active i{display: none;_display:none !important;}
.VipLeft .List a.cur,.VipLeft .List a:hover{color: #ffffff;background: #f24343;}
.VipLeft .List a.cur i,.VipLeft .List a:hover i{display: block;}
.VipRight{width: 1030px;float: right;}
.study-type {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  justify-content: center;
  li {
    text-align: center;
    font-weight: bold;
    color: #666;
    padding: 5px 20px 10px 20px;
    margin-right: 30px;
    cursor: pointer;
    font-size: 22px;
    &::after {
      content: " ";
      display: block;
      margin: 5px auto 0 auto;
      width: 90px;
      height: 5px;
      background: #fff;
    }
    &:hover {
      color: #2595fd;
    }
    &.active {
      color: #2595fd;
      &::after {
        background: linear-gradient(#27a4ff 21.43%, #227efa 95.7%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mall/study/ExerciseStore.vue